<template>
  <div class="yunxiao parent parent-forbid">
    <van-empty
      image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
      image-size="100"
    >
      <template #description>
        <div class="msg">{{ message }}</div>
      </template>
    </van-empty>
    <van-button
      class="action-btn"
      type="primary"
      square
      round
      @click="switchCompany"
    >切换机构</van-button>
    <van-button
      class="action-btn logout-btn"
      square
      round
      plain
      @click="logout"
    >退出登录</van-button>
  </div>
</template>

<script>
export default {
  name: "parentForbid",
  data() {
    return {
      pageTitle: '无法访问'
    }
  },
  computed: {
    message() {
      return this.$route.query.type === 'stop'
        ? '该机构已停用，请联系机构老师'
        : '该机构服务已过期，请联系机构老师';
    }
  },
  methods: {
    switchCompany() {
      this.$router.replace('/switchCompany');
    },
    logout() {
      app.parent.switchUser();
    }
  }
}
</script>

<style lang="scss" scoped>
.yunxiao.parent.parent-forbid {
  padding: calc(var(--gap) * 40) calc(var(--gap) * 16);
  background-color: var(--g1);
  text-align: center;
  min-height: 100vh;
  .msg {
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
    color: var(--g8);
    margin-top: calc(var(--gap) * 8);
  }
  .action-btn {
    display: block;
    width: 60%;
    margin: calc(var(--gap) * 16) auto 0;
    background-color: var(--c1);
    border-color: var(--c1);
  }
  .logout-btn {
    background-color: var(--white);
    color: var(--g8);
    border-color: var(--g4);
  }
}
</style>
